import React from "react";
import SupportLayout from "../support/SupportLayout";
import SupportOfficerHomeContent from "../support-officer/components/SupportOfficerHomeContent";

const SupportExecutiveHomeWrapper = () => {
  return (
    <SupportLayout userRole="SE">
      <SupportOfficerHomeContent userRole="SE" useOwnLayout={false} />
    </SupportLayout>
  );
};

export default SupportExecutiveHomeWrapper;
